<template>
  <div class="tw:flex tw:flex-col tw:lg:flex-row tw:border-t tw:border-gray-300 tw:pt-6">
    <div class="tw:w-full tw:lg:w-1/2">
      <h1 class="tw:flex tw:gap-2 tw:items-center tw:text-xl tw:font-bold tw:mb-4">
        <span class="tw:font-bold tw:bg-decorative-red tw:text-white tw:text-xxs tw:px-[6px] tw:py-[2px] tw:rounded">{{
          $t('New')
        }}</span
        >{{ $t('rc_smartboost_benefit_header') }}
      </h1>
      <ul class="tw:gap-y-1 tw:flex tw:flex-col tw:mb-5">
        <li v-for="(point, index) in points" :key="`point_${index}`" class="tw:flex tw:items-center tw:gap-x-2">
          <CheckPointIcon />
          {{ $t(point) }}
        </li>
      </ul>
      <GhostButton @click="switchToPayPerStayFn" size="medium">{{
        currentPartnerData?.canNetCpa ? $t('rc_performance_cpc_cpa_change') : $t('rc_cpc_cpa_cta')
      }}</GhostButton>
    </div>
    <div class="tw:hidden tw:lg:flex tw:w-full tw:lg:w-1/2 tw:flex tw:lg:justify-end">
      <img :src="smartBoostImage" :alt="$t('rc_smartboost_tab')" class="tw:lg:max-w-[295px]" />
    </div>
  </div>
</template>
<script setup>
import { computed } from 'vue'
import { useRouter } from 'vue-router'

import GhostButton from '@/components/base/buttons/GhostButton.vue'
import CheckPointIcon from '@/components/icons/CheckPointIcon.svg?component'

import { useIsMobile } from '@/composables/useIsMobile'
import { useSessionValues } from '@/composables/useSessionValues'
import { selectedAccommodationId } from '@/layouts/queries'
import { useCampaign, usePartners } from '@/components/rateConnect/queries'

import appAnalytics from '@/utils/tracking'

const router = useRouter()
const smartBoostImages = import.meta.glob('/src/assets/img/smart-boost/*.svg', {
  eager: true,
  query: '?url',
  import: 'default',
})
const { screenWidth } = useIsMobile()
const { language } = useSessionValues()
const { currentPartner } = useCampaign(selectedAccommodationId)
const { activePartnersData } = usePartners(selectedAccommodationId)
const currentPartnerData = computed(() =>
  activePartnersData.value?.find(item => item.partnerId === currentPartner.value)
)
const currentLocation = computed(() => {
  const parts = language.value.split('-')
  return (parts[1] || parts[0] || 'us').toLowerCase()
})
const screenSize = computed(() => {
  if (screenWidth.value > 767) {
    return 'm'
  } else {
    return 's'
  }
})
const smartBoostImage = computed(() => {
  const path = `/src/assets/img/smart-boost/smartBoost_${screenSize.value}_${currentLocation.value}.svg`
  return smartBoostImages[path] || ''
})

const points = ['rc_smartboost_benefit_1', 'rc_smartboost_benefit_2', 'rc_smartboost_benefit_3']

const switchToPayPerStayFn = () => {
  appAnalytics.track(appAnalytics.events.HOMEPAGE_RATE_CONNECT_CPC_UPSELL_BTN_CLICKED, {
    accommodationId: selectedAccommodationId.value,
  })
  if (currentPartnerData.value?.canNetCpa) {
    router.push('/rate-connect/running/performance?changeCampaignModal=true')
  } else {
    const hasOtherNetCpaPartner =
      activePartnersData.value?.some(partner => partner.partnerId !== currentPartner.value && partner.canNetCpa) ??
      false

    if (hasOtherNetCpaPartner) {
      router.push('/rate-connect/running/performance?changePartner=true')
    } else {
      return
    }
  }
}
</script>
